export const headersPlanoTrabalho = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Nº Item', width: 4, key: 'numeroItem' },
  { text: 'Data Prevista', width: 5, key: 'dataPrevista' },
  { text: 'Produto Farmacêutico', width: 30, key: 'produtoFarmaceutico' },
  { text: 'Qtd Total', width: 5, key: 'qtdTotal' },
  { text: 'Valor Total', width: 5, key: 'valorTotal' },
];

export const valoresExibidosPlanoAcao: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  status: 'Status',
  fiscal: 'Fiscal',
  numeroPa: 'Nº do Plano de Ação',
  dataInicio: 'Data de Início',
  dataTermino: 'Data de Término',
  documentoSei: 'Documento SEI',
  objetivo: 'Objetivo',
  justificativa: 'Justificativa',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorFiscal: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
